<template>
  <div>
    <ImagesControl v-on:subcommand="subcommand" v-bind:images="slide.settings.images"></ImagesControl>
  </div>
</template>

<script>
import BaseSlide from './BaseSlide';
import ImagesControl from '../controls/ImagesControl';

export default {
	name: 'ImagesSlide',
	mixins: [BaseSlide],
	components: {
		ImagesControl,
	},
};
</script>

<style scoped></style>
